// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"8743d1b2","5541":"8743d1b2","5666":"619e63f2","5785":"8743d1b2","6450":"a33fad0a"}[chunkId] + ".chunk.css";
};